var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-input',{class:_vm.cssClass,attrs:{"value":_vm.displayValue,"label":_vm.displayLabel,"v-validate":_vm.vValidate,"name":_vm.name,"size":_vm.size},on:{"change":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }